import { ApiClientService, EntityApiService } from '@dofleini/security';

import { authentication } from '@/settings';

class SettingsApiService extends EntityApiService {
  
  update = (params, config) => {
    return ApiClientService.patch(this.getPath(null, params), params, config);
  }
}

export default new SettingsApiService(`${authentication.path}/api/setting`);
